import React, { useState, useEffect } from "react";
import Grid from 'apollo-react/components/Grid';

import IconButton from 'apollo-react/components/IconButton';
import Typography from 'apollo-react/components/Typography';

import Card from "apollo-react/components/Card";
import CardContent from "apollo-react/components/CardContent";
import makeStyles from '@mui/styles/makeStyles';
import Button from '../common/Button';
import Inspect from 'apollo-react-icons/Inspect';

import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axiosInstance from '../../axiosInstance';

const styles = {
  reminderInput: {
    fontSize: '11px',
    maxWidth: '90px',
    minHeight: '26px',
    borderRadius: '10px',
    border: '1px solid #D9D9D9',
    textAlign: 'center',
    padding: '4px 0px',
    fontWeight: '700',
  }
};

const useStyles = makeStyles(styles);

const Reminders = ({ persona }) => {
  const [thresholds, setThresholds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formValues, setFormValues] = useState({});
  const [errors, setErrors] = useState({});
  const classes = useStyles();
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);

    const fetchThresholds = async () => {
      try {
        const response = await axiosInstance.get("/api/thresholds");
        console.log('response', response);
        setThresholds(response.data || []);

        // Initialize form values based on fetched thresholds
        const initialValues = {};
        response.data.forEach((threshold) => {
          initialValues[threshold.id] = threshold.percentage || ''; // Default to empty string if no percentage
        });
        setFormValues(initialValues); // Set the form values here
      } catch (error) {
        console.error("Error fetching thresholds:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchThresholds();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    console.log(`Input Changed: ${name} = ${value}`);
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: null, // Clear the error for this field when the user starts typing
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Form Values:', formValues);

    try {
      // Send form values to the backend
      const response = await axiosInstance.put(
        `${process.env.REACT_APP_SERVER_URL}/api/thresholds/bulk`,
        formValues,
        { withCredentials: true }
      );

      const results = response.data; // Backend response with validation results
      console.log('Backend Results:', results);

      // Process validation results
      const newErrors = {};
      Object.entries(results).forEach(([id, result]) => {
        if (!result.success) {
          newErrors[id] = result.error; // Store error message for the specific threshold
        }
      });

      setErrors(newErrors); // Update errors in the state

      // Show success message if all thresholds are valid
      if (Object.keys(newErrors).length === 0) {
        toast.success('Thresholds updated successfully!');
        // navigate(0);
      } else {
        toast.error('Some thresholds have validation errors. Please fix them.');
      }
    } catch (err) {
      console.error("Error in handleSubmit:", err);
      toast.error("An unexpected error occurred while updating thresholds.");
    }
  };

  return (
    <form onSubmit={handleSubmit} style={{ marginTop: '20px', maxWidth: '97%' }}>
      <Grid container spacing={2}>
        {loading ? (
          <Typography variant="body2" style={{ margin: '8px 0' }}>
            {'Loading...'}
          </Typography>
        ) : (
          thresholds.map((threshold) => (
            <Grid item xs={12} md={4} key={threshold.id} style={{ padding: '0 0 0 20px', marginTop: '9px' }}>
              <Card tabIndex={0} interactive style={{ display: 'flex', width: '100%', height: '100%', borderRadius: '5px', padding: '0px', margin: '7px 0px', backgroundColor: 'white', maxHeight: '135px', overflow: 'hidden' }}>
                <Grid item xs={3} style={{ display: 'flex', flexBasis: '22%', padding: '10px', justifyContent: 'center', alignItems: 'center', backgroundColor: '#015FF1', minHeight: '119px' }}>
                  <IconButton disabled>
                    <Inspect style={{ color: '#FFFFFF' }} />
                  </IconButton>
                </Grid>
                <Grid item xs={9} style={{ padding: '27px 13px' }}>
                  <CardContent>
                    <Typography variant="subtitle" gutterBottom style={{ fontWeight: '400' }}>
                      Number {threshold.id}
                    </Typography>
                    <Typography variant="bodySmall" gutterBottom emphasis="high" style={{ fontWeight: '700', marginTop: '19px' }}>
                      {threshold.editable ? (
                        <>
                          <input
                            type="text"
                            onChange={handleInputChange}
                            className={classes.reminderInput}
                            name={threshold.id}
                            value={formValues[threshold.id] || ''}
                            placeholder="Add here %"
                          />
                          {errors[threshold.id] && (
                            <Typography variant="body2" style={{ color: 'red', marginTop: '5px' }}>
                              {errors[threshold.id]}
                            </Typography>
                          )}
                        </>
                      ) : (
                        <div style={{ display: 'flex', alignItems: 'center', backgroundColor: '#D9D9D9', padding: '3px 10px', borderRadius: '24px', width: 'fit-content' }}>
                          {threshold.percentage}
                        </div>
                      )}
                    </Typography>
                  </CardContent>
                </Grid>
              </Card>
            </Grid>
          ))
        )}
      </Grid>
      <div style={{ display: 'block', marginTop: '41px', textAlign: 'right' }}>
        <Button
          color="primary"
          type="submit"
          style={{
            padding: "12px 22px",
            width: "157px",
            height: '40px',
            borderRadius: "20px",
            backgroundColor: "#015FF1",
          }}
          text="Save"
        />
      </div>
    </form>
  );
};

export default Reminders;